import { render } from "./UnfoldedTable.vue?vue&type=template&id=06c586a6&scoped=true&ts=true"
import script from "./UnfoldedTable.vue?vue&type=script&lang=ts"
export * from "./UnfoldedTable.vue?vue&type=script&lang=ts"

import "./UnfoldedTable.vue?vue&type=style&index=0&id=06c586a6&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c586a6"]])

export default __exports__